import React from "react";
import { Spin } from "antd";
import {Container} from "./Styled";

type LoaderProps = {
  children?: React.ReactNode;
  isLoading: boolean;
};

const Loader: React.FunctionComponent<LoaderProps> = ({ children, isLoading })  => {
  return (
    <Container>
        <Spin wrapperClassName="LoaderSpin" size="large" spinning={isLoading} delay={100}>
            {children}
        </Spin>
    </Container>
  );
};

export default Loader; 